const brokerCustomWalletGetPortfoliosListAction = require('./brokerCustomWalletGetPortfoliosList');
const brokerCustomWalletGetPortfolioDetailsActions = require('./brokerCustomWalletGetPortfolioDetails');
const brokerCustomWalletDeletePortfolioActions = require('./brokerCustomWalletDeletePortfolio');
const brokerCustomWalletEditPortfolioActions = require('./brokerCustomWalletEditPortfolio');
const brokerCustomWalletChangePortfolioActions = require ('./brokerCustomWalletChangePortfolio')

module.exports = {
    getPortfolioList: brokerCustomWalletGetPortfoliosListAction.getPortfolioList,
    getDetailsByPortfolio: brokerCustomWalletGetPortfolioDetailsActions.getDetailsByPortfolio,
    removeWallet: brokerCustomWalletDeletePortfolioActions.removeWallet,
    setPortfolioToDelete: brokerCustomWalletDeletePortfolioActions.setPortfolioToDelete,
    setExpanded: brokerCustomWalletGetPortfoliosListAction.setExpanded,
    cancelDelete: brokerCustomWalletDeletePortfolioActions.cancelDelete,
    cancelChangeDefault: brokerCustomWalletChangePortfolioActions.cancelChangeDefault,
    confirmedChangeDefault: brokerCustomWalletChangePortfolioActions.confirmedChangeDefault,
    changeDefault: brokerCustomWalletChangePortfolioActions.changeDefault,
    changeDefaultConfirmed: brokerCustomWalletChangePortfolioActions.changeDefaultConfirmed,
    changeDefaultCheckboxChanged: brokerCustomWalletChangePortfolioActions.changeDefaultCheckboxChanged,
    requestEditionMode: brokerCustomWalletEditPortfolioActions.requestEditionMode,
    acceptLeaveEditionToDelete: brokerCustomWalletEditPortfolioActions.acceptLeaveEditionToDelete,
    acceptLeaveEditionToEdition: brokerCustomWalletEditPortfolioActions.acceptLeaveEditionToEdition,
    cancelLeaveEdition: brokerCustomWalletEditPortfolioActions.cancelLeaveEdition,
    cancelEdition: brokerCustomWalletEditPortfolioActions.cancelEdition,
    leaveEditionToDelete: brokerCustomWalletEditPortfolioActions.leaveEditionToDelete,
    leaveEditionToEdition: brokerCustomWalletEditPortfolioActions.leaveEditionToEdition,
    setPortfolioOnEditionMode: brokerCustomWalletEditPortfolioActions.setPortfolioOnEditionMode,
    setPortfolioOnNextEditMode: brokerCustomWalletEditPortfolioActions.setPortfolioOnNextEditMode,
    rejectConflictEditMode: brokerCustomWalletEditPortfolioActions.rejectConflictEditMode,
    setPortfolioOnViewMode: brokerCustomWalletEditPortfolioActions.setPortfolioOnViewMode,
    confirmLeaveEditionToOtherPage: brokerCustomWalletEditPortfolioActions.confirmLeaveEditionToOtherPage,
    updatePortfolio: brokerCustomWalletGetPortfolioDetailsActions.updatePortfolio,
    getIdDefaultView: brokerCustomWalletGetPortfoliosListAction.getIdDefaultView
}
